import { render, staticRenderFns } from "./TaskBody.vue?vue&type=template&id=39c8af80&scoped=true&"
import script from "./TaskBody.vue?vue&type=script&lang=js&"
export * from "./TaskBody.vue?vue&type=script&lang=js&"
import style0 from "./TaskBody.vue?vue&type=style&index=0&id=39c8af80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c8af80",
  null
  
)

export default component.exports